import { render, staticRenderFns } from "./SimulatorDevBanner.vue?vue&type=template&id=3f775c12&scoped=true&"
import script from "./SimulatorDevBanner.vue?vue&type=script&lang=js&"
export * from "./SimulatorDevBanner.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorDevBanner.vue?vue&type=style&index=0&id=3f775c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f775c12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
